export const IMG_URL = 'http://image.tmdb.org/t/p/';

export const IMG_SIZES = {
  w300: 'w300',
  w780: 'w780',
  w1280: 'w1280',
  original: 'original'
};
